import React from 'react';

import { StyledImage } from './styles';
import { IImage } from './index';

const Image: React.FC<IImage> = ({
    alt,
    src,
    maxWidth,
    disableLazyLoad = false,
    center = false,
    className,
    mb,
    dataLocator,
    onClick,
}) => {
    if (!src) return null;

    return (
        <div className="image-outer-wrapper">
            <StyledImage
                $maxWidth={maxWidth}
                $center={center}
                src={src}
                alt={alt}
                $mb={mb}
                className={className}
                data-locator={dataLocator}
                onClick={onClick}
                loading={disableLazyLoad ? 'eager' : 'lazy'}
            />
        </div>
    );
};

export { Image };
